<template>
  <div class="module_page page_content institution" aria-label="Institution Summary view content page">

    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
      </div>
      <div class="col-4 btn_container text-right pagination_sty3">
        <button type="button" class="btn btn-primary" :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</button>
        <b-btn @click="generate">generate</b-btn>
      </div>
    </div>

    <div class="page_content_container">

      <institution-menu :uuid="uuid" :active="'apiConfig'"></institution-menu>

      <div class="row pg_content">
		    <div class="col-12">
          <div class="course-management-section">
            <div class="page_subheading">
              <div class="col-5" style="padding-left: 0px;"></div>
              <div class="col-7 btn_container pagination_sty3">
                <button type="button" :disabled="this.firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                  <option v-for="option in sizeOptions" v-bind:value="option">
                  {{ option }}
                  </option>
                </select>
              
                <button type="button" :disabled="this.lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button></div>
            </div>

            <div class="course-management-table-container">
              <table v-if="isDataLoaded" class="table b-table table-bordered border">
                <thead class="thead-light text-center">
                  <tr>
                    <th class="first-column">
                      <label class="form-checkbox">
                        <input type="checkbox" v-model="selectAll" @click="select" :disabled="(apiConfigs.length === 0) || permission.systemPermission.readOnly" aria-label="select all configs">
                        <i class="form-icon"></i>
                      </label>
                    </th>
                    <th class="second-column">Key</th>
                    <th class="third-column">Secret</th>
                    <th class="fourth-column">Action</th>
                  </tr>
                </thead>
                <tbody v-if="apiConfigs.length > 0">
                  <tr v-for="apiConfig in apiConfigs">
                    <td class="first-column  text-center">
                      <label class="form-checkbox">
                        <input type="checkbox" :value="apiConfig.uuid" v-model="selected" :state="deselect" :disabled="(apiConfigs.length === 0) || permission.systemPermission.readOnly" aria-label="select config">
                        <i class="form-icon"></i>
                      </label>
                    </td>
                    <td class="second-column text-center">{{apiConfig.key}}</td>
                    <td class="third-column">{{apiConfig.secret}}</td>
                    <td class="fourth-column">
                      <template v-if="permission.systemPermission.readOnly">
                        <span class="action-link icon-pencil" aria-label="edit" tabindex="0" style="pointer-events: none; color: #ccc;"></span>
                      </template>
                      <template v-else>
                        <span class="action-link icon-pencil" @click="edit(apiConfig)" aria-label="edit" tabindex="0" style="cursor: pointer"></span>
                      </template>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <b-modal v-model="showApiKeyModal" title="API Key" :header-bg-variant="'warning'" :header-text-variant="'dark'" :footer-bg-variant="'light'" no-close-on-backdrop no-close-on-esc centered>
              <div class="text-center" @keydown.enter="generateOrEditApiConfig">
                <div class="float-left mr-3 mt-2">
                  <div class="fld-label">Key</div>
                </div>
                <div class="ml-5" style="width: 80%;">
                  <b-form-input v-model="key" :state="keyState" aria-labelledby="api key" placeholder="Key" aria-describedby="keyFeedback" style="height: 1.5em !important;" @input="v => {key = ((v) ? v.trim().toUpperCase() : null)}">
                  </b-form-input>
                  <b-form-invalid-feedback id="keyFeedback">
                    Key must not be empty
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div slot="modal-footer" class="w-100">
                <b-button variant="primary" size="sm" class="float-right ml-3" @click="generateOrEditApiConfig" :disabled="!dirty">ok</b-button>
                <b-button variant="primary" size="sm" class="float-right" @click="hideApiKeyModal">cancel</b-button>
              </div>
            </b-modal>
          </div>

          <div>
            <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
              <div style="text-align: center;">
                  <h6>Are you sure you want delete these ({{ selected.length }}) configs?</h6>
              </div>
              <div slot="modal-header" class="header-section">
                <div class="popup-heading">Please Confirm!</div>
                <button class="btn_close" aria-label="close" @click="cancelDelete">
                  <span class="ic-close"></span>
                </button>
              </div>
              <div slot="modal-footer" class="w-100">
                <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
                <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import InstitutionMenu from './InstitutionMenu'
import Vuelidate from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
Vue.use(Vuelidate)

export default {
  name: 'institutionApiConfiguration',
  props: ['uuid'],
  components: {
    InstitutionMenu
  },
  data: () => {
    return {
      apiConfigs: [],
      pageSize: 10,
      sizeOptions: [ 10, 50, 100 ],
      firstPage: true,
      lastPage: false,
      page: 0,
      selected: [],
      selectAll: false,
      isDataLoaded: false,
      showApiKeyModal: false,
      key: null,
      keyState: null,
      dbKey: null,
      apiConfigId: null,
      dirty: false,
      userObject: JSON.parse(localStorage.getItem('userobj')),
      superAdminPermissionName: 'SUPERADMIN_PERMISSION'
    }
  },
  validations: {
    key: {
      required
    }
  },
  watch: {
    key (val) {
      this.dirty = (val !== this.dbKey)
      if (val) {
        this.keyState = null
      }
    }
  },
  mounted () {
    this.loadConfigList()
  },
  methods: {
    ...mapActions([
      'loadApiConfigs',
      'loadGenerateOrEditApiConfig',
      'deleteApiConfigs'
    ]),
    loadConfigList () {
      this.hideApiKeyModal()
      this.loadApiConfigs({uuid: this.uuid, page: this.page, count: this.pageSize}).then(result => {
        this.apiConfigs = result.content
        this.firstPage = result.first
        this.lastPage = result.last
        this.page = result.number
        this.isDataLoaded = true
        if (this.selectAll) {
          this.selected = []
          this.selectAll = false
        }
      })
    },
    select () {
      this.selected = []
      if (!this.selectAll) {
        for (var i in this.apiConfigs) {
          this.selected.push(this.apiConfigs[i].uuid)
        }
      }
    },
    hideApiKeyModal () {
      this.key = null
      this.dbKey = null
      this.apiConfigId = null
      this.showApiKeyModal = false
    },
    generate () {
      this.key = null
      this.dbKey = null
      this.apiConfigId = null
      this.showApiKeyModal = true
    },
    generateOrEditApiConfig () {
      let isValid = true
      this.$v.key.$touch()
      if (this.$v.key.$error) {
        this.keyState = false
        isValid = false
      }
      if (isValid) {
        this.showApiKeyModal = false
        let apiConfig = {
          key: this.key,
          institutionId: this.uuid
        }
        let status = 'success'
        let text = 'API config with key "' + this.key + '" created successfully.'
        if (this.apiConfigId) {
          apiConfig.uuid = this.apiConfigId
          text = 'API config with key "' + this.key + '" updated successfully.'
        }
        this.loadGenerateOrEditApiConfig(apiConfig).then(res => {
          if (res) {
            if (res.status === 409) {
              text = 'Key "' + this.key + '" already exists.'
              status = 'warn'
            }
            this.$notify({
              group: 'notify',
              type: status,
              title: '',
              text: text
            })
            this.loadConfigList()
          }
        })
      }
    },
    edit (apiConfig) {
      this.dirty = false
      this.key = apiConfig.key
      this.dbKey = apiConfig.key
      this.apiConfigId = apiConfig.uuid
      this.showApiKeyModal = true
    },
    showDeleteConfirm (apiConfig) {
      if (this.selected.length > 0) {
        this.$refs.deleteConfirmModal.show()
      }
    },
    deleteSelected () {
      this.$refs.deleteConfirmModal.hide()
      this.deleteApiConfigs(this.selected).then(res => {
        this.$notify({
          group: 'notify',
          type: 'success',
          title: '',
          text: 'API Config deleted successfully.'
        })
        setTimeout(() => {
          this.loadConfigList()
        }, 500)
      })
      this.selected = []
      this.selectAll = false
    },
    cancelDelete () {
      this.$refs.deleteConfirmModal.hide()
      this.selected = []
      this.selectAll = false
    },
    resetPage () {
      this.page = 0
      this.loadConfigList()
    },
    prev () {
      this.page -= 1
      this.loadConfigList()
    },
    next () {
      this.page += 1
      this.loadConfigList()
    }
  },
  computed: {
    ...mapState({
      'institution': state => state.institution.institution,
      'permission': state => state.user.permission
    }),
    isSuperAdmin () {
      let userObject = this.userObject
      let permission = userObject.permission || this.permission
      return permission.name === this.superAdminPermissionName
    },
    deselect () {
      if (this.selected.length === this.apiConfigs.length) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/InstitutionApiConfiguration.vue